import BarChartJS from 'general/components/ChartJS/BarChartJS';
import Utils from 'general/utils/Utils';
import PropTypes from 'prop-types';

BarChart.propTypes = {
  title: PropTypes.string,
  labels: PropTypes.array,
  data: PropTypes.array,
  unit: PropTypes.string,
  color: PropTypes.string,
  hoverColor: PropTypes.string,
  showLine: PropTypes.bool,
};

function BarChart({
  title,
  labels,
  data,
  unit,
  color = '#8676FF4D',
  hoverColor = '#8676FF',
  showLine = false,
}) {
  return (
    <div className="h-100 w-100">
      <BarChartJS
        dataType={showLine ? 'revenue' : ''}
        horizontal={false}
        showTitle={false}
        labels={labels}
        datasets={[
          {
            label: title,
            data: data,
            borderColor: color,
            backgroundColor: color,
            hoverColor: hoverColor,
            appendUnit: unit,
            stepSize: Utils.getNearestMultipleOfFive(Math.max(...data)) / 5,
            max: Utils.getNearestMultipleOfFive(Math.max(...data)),
          },
        ]}
      />
    </div>
  );
}

export default BarChart;
